import React from "react";
import UiFormControlSelection from "../../common/ui/UiFormControlSelection";
import UiFormField from "../../common/ui/UiFormField";

export default function HomeAddressForm({ states = [], ...rest }) {
  return (
    <>
      <UiFormField
        type="text"
        placeholder="Street (Required)"
        label="Street (Required)"
        labelSize={false}
        fieldName="street_1"
        maxLength={255}
        showFloatingLabel={true}
      />
      <UiFormField
        type="text"
        placeholder="Street Line 2 (Optional)"
        label="Street Line 2 (Optional)"
        labelSize={false}
        fieldName="street_2"
        maxLength={255}
        showFloatingLabel={true}
      />
      <UiFormField
        type="text"
        placeholder="City (Required)"
        label="City (Required)"
        labelSize={false}
        fieldName="city"
        maxLength={35}
        showFloatingLabel={true}
      />

      <div className="home-address--containerSmall">
        <UiFormControlSelection
          type="autoComplete"
          label={"State (Required)"}
          showFloatingLabel={true}
          fieldName="state"
          optionsData={states}
          optionValue={"name"}
          optionKey={"id"}
        />
        <UiFormField
          type="text"
          placeholder="Zip Code (Required)"
          label="Zip Code (Required)"
          labelSize={false}
          fieldName="zip"
          showFloatingLabel={true}
        />
      </div>
    </>
  );
}
